import { Button } from '@heidi/design-system/button';
import { cn } from '@heidi/utils';
import { ChevronDown } from 'lucide-react';

interface ScrollDownIndicatorProps {
  isVisible: boolean;
  onClick: () => void;
  className?: string;
}

/**
 * A floating chevron indicator that appears when there's more content
 * below the visible viewport. Clicking it scrolls to the bottom.
 */
export const ScrollDownIndicator = ({
  isVisible,
  onClick,
  className,
}: ScrollDownIndicatorProps): JSX.Element => {
  return (
    <div
      className={cn(
        'flex justify-end pb-2 pr-4 transition-opacity duration-100 ease-out sm:pb-4',
        isVisible ? 'pointer-events-auto opacity-100' : 'pointer-events-none opacity-0',
        className
      )}
    >
      <Button
        variant="outline"
        size="sm"
        iconOnly
        onClick={onClick}
        className="rounded-md border border-border bg-surface shadow-sm transition-colors duration-200 ease-out hover:bg-surface-hover"
        aria-label="Scroll to bottom"
        tabIndex={isVisible ? 0 : -1}
      >
        <ChevronDown className="size-4 text-text-secondary" />
      </Button>
    </div>
  );
};
